import React from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class SelectWithLabel extends React.Component {
  id = String(Math.random());

  constructor(props) {
    super(props);

    this.state = {};
  }

  setLabelRef = inputLabelRef => {
    this.inputLabelRef = inputLabelRef;

    const labelWidth = inputLabelRef && inputLabelRef.offsetWidth;

    if (labelWidth) {
      this.setState({ labelWidth });
    }
  }

  render() {
    const { labelWidth } = this.state;
    const {
      value, label, children, onChange, ...otherProps
    } = this.props;

    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel ref={this.setLabelRef} id={this.id}>
          {label}
        </InputLabel>
        <Select
          labelWidth={labelWidth}
          labelId={this.id}
          value={value}
          onChange={onChange}
          fullWidth
          variant="outlined"
          inputProps={{
            value,
          }}
          {...otherProps}
        >
          {children}
        </Select>
      </FormControl>
    );
  }
}

SelectWithLabel.propTypes = {
  value: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func.isRequired,
};

SelectWithLabel.defaultProps = {
  value: '',
};

export default SelectWithLabel;
